import { ConnectionStatus } from '@ambit-ai/ambit-client';

import { START_CONNECTION, CONNECTION_CHANGE, ONLINE_CHANGE } from './actions';

const initialState = {
  connectionStatus: ConnectionStatus.Uninitialized,
  botConnection: undefined,
  user: undefined,
  online: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case START_CONNECTION:
      return {
        ...state,
        botConnection: action.botConnection
      };
    case CONNECTION_CHANGE:
      return {
        ...state,
        user: action.botConnection.user,
        conversationId: action.botConnection.conversationId,
        connectionStatus: action.connectionStatus
      };
    case ONLINE_CHANGE:
      return {
        ...state,
        online: action.online
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/connection/reducer.js